'use client'

import { useTranslations } from 'next-intl'
import {
  ComponentProps,
  RefObject,
  useCallback,
  useEffect,
  useState,
} from 'react'

import {
  cn,
  CopyButton,
  ScrollProgressBar,
  STICKY_EVENT,
  subscribeEvent,
  unsubscribeEvent,
} from '@/shared/lib'
import { Icon } from '@/shared/ui'

type Props = ComponentProps<'div'> & {
  ref?: RefObject<HTMLDivElement>
  title: string
}

export const Header = ({ title, ref, ...props }: Props) => {
  const [stuck, setStuck] = useState(false)
  const [currentUrl, setCurrentUrl] = useState('')

  const t = useTranslations('magazine_detail')

  const handleStickyChange = useCallback(
    (event: CustomEvent) => {
      if (ref?.current) {
        setStuck(event.detail.stuck)
      }
    },
    [ref],
  )

  useEffect(() => {
    setCurrentUrl(window.location.href)
  }, [])

  useEffect(() => {
    subscribeEvent(STICKY_EVENT, handleStickyChange)

    return () => {
      unsubscribeEvent(STICKY_EVENT, handleStickyChange)
    }
  }, [handleStickyChange])

  return (
    <div
      className={cn(
        'flex h-14 w-[700px] items-center justify-center bg-white',
        stuck && 'shadow-[0_0_10px_0_rgba(0,0,0,0.15)]',
      )}
      ref={ref}
      {...props}
    >
      <h2 className="typo-label1 font-normal text-black">{title}</h2>
      <CopyButton
        value={currentUrl}
        successMessage={t('toast.link_copied')}
        asChild
      >
        <button className="absolute top-1/2 right-6 h-fit w-fit -translate-y-1/2 cursor-pointer">
          <Icon name="share" size={24} strokeWidth={1.5} />
          <span className="sr-only">공유하기</span>
        </button>
      </CopyButton>
      <ScrollProgressBar className="absolute top-full right-0" />
    </div>
  )
}
